<layout-master
  [headerButtonsTemplate]="headerButtons"
></layout-master>

<ng-template #headerButtons>
  <div class="fw-light font-size-default no-underline" *ngIf="session">
    <debug-setter
      [buttonType]="'native-link'"
      [buttonNgClass]="'link-underline-light text-light no-underline'"
      [iconNgClass]="'valign-middle font-size-22 text-light no-underline'"
      [ngClass]="'me-1 text-light no-underline'"
    ></debug-setter>
    <a routerLink="/account" class="p-0 m-0 link-underline-light text-light no-underline">
      <mat-icon class="valign-middle font-size-22">account_circle</mat-icon>
      {{session.identity.sub}}
    </a>
    <a routerLink="/auth/logout" class="p-0 m-0 ms-2 link-underline-light text-light no-underline">
      <mat-icon class="valign-middle font-size-22">exit_to_app</mat-icon>
    </a>
  </div>
</ng-template>

